import React from 'react';
import Page from '../../components-core/Page';
import { useQuery } from 'react-fetching-library';
import { SnackbarAlert } from '../../components-core/SnackbarAlert';
import { getClientPaymentsAction } from '../../services/request';
import { CircularProgress } from '@mui/material';
import SettlementsTable from '../../sections/client/settlements/SettlementsTable';

const Settlement = () => {
  const [payments, setPayments] = React.useState([]);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const { query, loading, payload, error } = useQuery(getClientPaymentsAction());

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setPayments(payload);
    }
    if (error) {
      setOpenSnackbar(true);
    }
  }, [loading]);

  return (
    <Page title="Płatności za zajęcia">
      {loading ? <CircularProgress /> : <SettlementsTable payments={payments} orderQuery={query}/>}
      <SnackbarAlert open={openSnackbar} severity="error" message="Wystąpił błąd" onClose={handleCloseSnackbar} />
    </Page>
  );
};


export default Settlement;
